import React, { useEffect } from 'react'

const offCanvasWidth = "23%"
const showCanvasWhenScreenWidthAbove = "600"

const OffCanvasComponent = ({ renderElements , topCustomClass}) => {
    useEffect(() => {
        if (screen.width > showCanvasWhenScreenWidthAbove) {
            setTimeout(() => {
                jQuery('#offCanvasWindow').css("width", offCanvasWidth);
                jQuery('.content-body').css("width", `calc(100% - ${offCanvasWidth})`);
            }, 5);
        }
    }, [])
    return (
        <>
            {
                screen.width > showCanvasWhenScreenWidthAbove ?
                    <div className={`off-canvas show off-canvas-right ${topCustomClass==true ? 'off-canvas-top-zero' :''}`} style={{ zIndex: '0' }} id="offCanvasWindow">
                        {renderElements}
                    </div>
                    : null
            }
        </>
    )
}

export default OffCanvasComponent;
